import { useFieldArray, useFormContext } from "react-hook-form";

import { FormValues } from "../new-employee-form";
import { DataTable } from "./new-documents-table/data-table";
import { columns } from "./new-documents-table/columns";

interface NewEmployeePersonalProps {
  isPending: boolean;
}

export const NewDocuments = ({ isPending }: NewEmployeePersonalProps) => {
  const form = useFormContext<FormValues>();

  const {
    fields: documentFields,
    append: appendDocument,
    remove: removeDocument,
    update: updateDocument,
  } = useFieldArray({
    name: "documents",
    control: form.control,
  });

  return (
    <div className="flex flex-col">
      <h2 className="text-lg font-medium">Documents</h2>

      <DataTable
        isPending={isPending}
        columns={columns}
        data={documentFields}
        removeDocumentRow={removeDocument}
        appendDocumentRow={appendDocument}
        updateDocumentRow={updateDocument}
      />
    </div>
  );
};
